// components/PhotographyCards.tsx
import { Box, Grid, Heading, Image, Link, Text, VStack } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

const cardsByLang = {
  'ES': [
    {
      title: "Galerías",
      imageUrl: "/img/ph-gallery.jpg",
      alt: "Imagen de una galería",
      link: '/photography/photo'
    },
    {
      title: "Vehículos",
      imageUrl: "/img/ph-auto.jpg",
      alt: "Imagen de un vehículo",
      link: '/photography/vehicles'
    },
    {
      title: "Producto",
      imageUrl: "/img/ph-prod.jpg",
      alt: "Imagen de un producto",
      link: '/photography/products'
    },
    // {
    //   title: "Inmuebles",
    //   imageUrl: "/img/ph-houses.webp",
    //   alt: "Imagen de una casa",
    //   link: '/photography/houses'
    // }
  ],
  'EN': [
    {
      title: "Galleries",
      imageUrl: "/img/ph-gallery.jpg",
      alt: "Gallery photo",
      link: '/photography/photo'
    },
    {
      title: "Vehicles",
      imageUrl: "/img/ph-auto.jpg",
      alt: "Vehicle photo",
      link: '/photography/vehicles'
    },
    {
      title: "Products",
      imageUrl: "/img/ph-prod.jpg",
      alt: "Product photography image",
      link: '/photography/products'
    },
    // {
    //   title: "Houses",
    //   imageUrl: "/img/ph-houses.webp",
    //   alt: "Houses photography image",
    //   link: '/photography/houses'
    // }
  ]
};

export default function PhotographyBrowser({lang='ES'}) {

  return (
    <Box maxW="7xl" mx="auto" px={{ base: 4, md: 8 }} pt={24} minH={"100vh"}>
      <Heading as="h2" size="xl" mb={8}>
        Fotografía
      </Heading>
      <Grid
        templateColumns={{ base: "1fr", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }}
        gap={8}
      >
        {cardsByLang[lang].map((card) => (
          <VStack key={card.title} spacing={4} align="center" transitionDuration={'0.5s'} _hover={{ transform: 'scale(1.005);' }}>
            <Link as={RouterLink} w='100%' h='100%' to={card.link}>
              <Box w="100%" aspectRatio={4 / 3} overflow="hidden" borderRadius="md">
                <Image
                  src={card.imageUrl}
                  alt={card.alt}
                  objectFit="cover"
                  w="100%"
                  h="100%"
                />
              </Box>
              <Text fontWeight="bold" fontSize="lg" decoration={'none'}>
                {card.title}
              </Text>
            </Link>
          </VStack>
        ))}
      </Grid>
    </Box>
  );
}
